import { ReactNode } from 'react';

import { clsx } from 'clsx';

import cls from './TabList.module.scss';

type TabListProps = {
  className?: string;
  children: ReactNode;
};

export const TabList = ({ children, className }: TabListProps) => {
  return <div className={clsx(cls.wrap, className)}>{children}</div>;
};
